module.exports = __webpack_public_path__ + "static/media/daisy-ridley-win.5d178acf.jpg";